import { Injectable, ApplicationRef } from '@angular/core';

enum FileReadFormat {
  base64,
  arrayBuffer,
  binaryString,
  text
}

export enum FileType {
  image = 'image/jpeg, image/jpg, image/png',
  any = '',
}


@Injectable({
  providedIn: 'root'
})
export class FileReaderService {

  constructor(private cd: ApplicationRef) { }
/*
  readFromSystem( 
    config:{ readType: FileReadFormat, file: FileType, multiple:boolean } = { readType: FileReadFormat.arrayBuffer, file: FileType.any, multiple:false } 
    ) {

  
      let input: HTMLElement = document.createElement('input') as HTMLInputElement;
      input.setAttribute('type', 'file');
      input.setAttribute('accept', config.file);
      if (config.multiple) {
        input.setAttribute('multiple', 'multiple');
      }    
    input.onchange = (e: any) => {
      if (e.target.files.length == 0) {
        return config.multiple ? [] : null;
      }

      let fileListPromise = [];

      
      for (let i = 0; i < e.target.files.length; i++) {
        let file = this.read(e.target.files[i], config.readType);
        fileListPromise.push(file);
      }
      forkJoin(fileListPromise).toPromise().then(r => {

      });
    }
    input.click();
  }*/

  readAsBase64(file): Promise<any> {
    return this.read(file, FileReadFormat.base64);
  }

  // o msm q readAsNase64()
  readAsDataUrl(file): Promise<any> {
    return this.read(file, FileReadFormat.base64);
  }

  readAsArrayBuffer(file): Promise<any> {
    return this.read(file, FileReadFormat.arrayBuffer);
  }

  readAsBinaryString(file): Promise<any> {
    return this.read(file, FileReadFormat.binaryString);
  }

  readAsText(file): Promise<any> {
    return this.read(file, FileReadFormat.text);
  }

  private read(file, readType: FileReadFormat) {

    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.onload = () => {
        if (!fileReader.error) {
          this.cd.tick();
          resolve(fileReader.result);
        }
      };

      fileReader.onerror = (e) => {
        this.cd.tick();
        reject(e);
      };

      try {

        switch (readType) {
          case FileReadFormat.base64:
            fileReader.readAsDataURL(file);
            break;

          case FileReadFormat.arrayBuffer:
            fileReader.readAsArrayBuffer(file);
            break;

          case FileReadFormat.binaryString:
            fileReader.readAsBinaryString(file);
            break;

          case FileReadFormat.text:
            fileReader.readAsText(file);
            break;

          default:
            fileReader.readAsDataURL(file);
            break;
        }

      } catch (error) {
        reject(error);
      }

    });
  }

}
